/* Catalyst: concise copy for Shopify's native cookie banner. Consent actions remain native. */
(function () {
  if (window.__catalystCookieCopyReady) return;
  window.__catalystCookieCopyReady = true;

  const COPY = 'Cookies help us improve your experience.';

  function setButtonText(root, selector, fallbackMatch, text) {
    let button = root.querySelector(selector);
    if (!button) {
      button = Array.from(root.querySelectorAll('button')).find((el) =>
        fallbackMatch.test(`${el.id || ''} ${el.className || ''} ${el.textContent || ''}`)
      );
    }
    if (button && button.textContent.trim() !== text) button.textContent = text;
  }

  function rewriteCookieCopy() {
    const root = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
    if (!root) return;

    const heading = root.querySelector('.shopify-pc__banner__body-title, h2, h3');
    if (heading && heading.textContent.trim() !== 'Cookies') heading.textContent = 'Cookies';

    const paragraph = root.querySelector('.shopify-pc__banner__body p, .shopify-pc__banner__dialog p, p');
    if (paragraph && paragraph.textContent.trim() !== COPY) paragraph.textContent = COPY;

    setButtonText(root, '.shopify-pc__banner__btn-accept', /accept/i, 'Accept all');
    setButtonText(root, '.shopify-pc__banner__btn-decline', /decline|reject/i, 'Reject all');
    setButtonText(root, '.shopify-pc__banner__btn-manage-prefs', /manage|preference/i, 'Preferences');
  }

  function start() {
    rewriteCookieCopy();
    const observer = new MutationObserver(rewriteCookieCopy);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
